import React, { FC, useEffect } from 'react';
import * as analytics from '@adsk/acs-web-analytics';
import { PageNotFound } from '@adsk/alloy-error-page';
import { LinkButton } from '@adsk/alloy-react-button';
import { report, REPORT_TYPES } from '@adsk/exo-skeleton-api';
import { ANALYTICS_TYPES } from '../../analytics';
import i18n from '../../utils/i18n';

const analyticReportAndNavigate = () => {
  analytics.track(ANALYTICS_TYPES.EXO_NAVIGATE_RESULT_404_GO_HOME);
};

const PageNotFoundExo: FC = () => {
  useEffect(() => {
    analytics.track(ANALYTICS_TYPES.EXO_NAVIGATE_RESULT_404, {
      requested_url: window.location.href,
    });

    void report({
      type: REPORT_TYPES.warning,
      value: 'Page not found',
      context: {
        requested_url: window.location.href,
      },
    });
  }, []);

  return (
    <PageNotFound
      action={
        <LinkButton as="a" href="/" onClick={analyticReportAndNavigate}>
          {i18n.t('GO_HOME')}
        </LinkButton>
      }
    />
  );
};

export default PageNotFoundExo;
